import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Button, Avatar } from "@mui/material";
import * as CategoryActions from '../../../redux/actions/categoryAction.js';
import * as SubCategoryActions from '../../../redux/actions/subCategoryAction.js';
import * as YatraActions from '../../../redux/actions/yatraAction.js';
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { RedirectPageData } from "../../../utils/static-data/index.js";
import { AddSvg, CrossSvg } from "../../../assets/svg/index.js";

const AddPackage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categoryData } = useSelector(state => state.categoryReducer);
  const { subCatgeoryDataByCategoryId } = useSelector(state => state.subCategoryReducer);
  const [childCategories, setChildCategories] = useState([]);

  const redirectCategoryData = categoryData.filter(value => value?.redirect_page === 'Yatra');   //* Redirect Category Data For Category Name Option
  // const categoryData = [{ _id: 1, redirectPage: "Podcast", categoryName: "Podcast Category", status: "Active" }, { _id: 2, redirectPage: "Videoclip", categoryName: "Videoclip Category", status: "Inactive" }, { _id: 3, redirectPage: "Podcast", categoryName: "Podcast Category", status: "Inactive" }]
  const [yatraPackageDetail, setYatraPackageDetail] = useState({ redirectPage: '', categoryId: '', subCategoryId: '', childCategoryId: '', yatraPackageName: '', yatraPackagePrice: '', yatraPackagePriceMax: '', yatraPackageDescription: '', status: '', yatraType: '' });
  const [inputFieldError, setInputFieldError] = useState({ redirectPage: '', categoryId: '', subCategoryId: '', childCategoryId: '', yatraPackageName: '', yatraPackagePrice: '', yatraPackagePriceMax: '', yatraPackageImage: '', yatraPackageDescription: '', status: '', yatraType: '' });
  const [yatraPackageImage, setYatraPackageImage] = useState({ file: logo_icon, bytes: "" });
  const [includedBullet, setIncludedBullet] = useState(['']);
  const [notIncludedBullet, setNotIncludedBullet] = useState(['']);

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setYatraPackageDetail({ ...yatraPackageDetail, [name]: value });
  };

  //* Handle Yatra Package Image
  const handleYatraPackageImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setYatraPackageImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }

    handleInputFieldError("yatraPackageImage", null)
  };

  //* Bullet Start
  const handleIncludedBulletChange = (index, e) => {
    const newBullet = [...includedBullet];
    newBullet[index] = e.target.value;
    setIncludedBullet(newBullet);
  };

  const handleAddIncludedBulletField = () => {
    setIncludedBullet([...includedBullet, '']);
  };

  const handleRemoveIncludedBulletField = (index) => {
    const newBullet = [...includedBullet];
    index !== 0 && newBullet.splice(index, 1);
    setIncludedBullet(newBullet);
  };

  // ============== 

  const handleNotIncludedBulletChange = (index, e) => {
    const newBullet = [...notIncludedBullet];
    newBullet[index] = e.target.value;
    setNotIncludedBullet(newBullet);
  };

  const handleAddNotIncludedBulletField = () => {
    setNotIncludedBullet([...notIncludedBullet, '']);
  };

  const handleRemoveNotIncludedBulletField = (index) => {
    const newBullet = [...notIncludedBullet];
    index !== 0 && newBullet.splice(index, 1);
    setNotIncludedBullet(newBullet);
  };
  //* Bullet End

  //! Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { categoryId, subCategoryId, yatraPackageName, yatraPackagePrice, yatraPackageDescription, yatraType } = yatraPackageDetail;
    const { bytes } = yatraPackageImage;

    if (!categoryId) {
      handleInputFieldError("categoryId", "Please Select Category Name")
      isValid = false;
    }
    if (!subCategoryId) {
      handleInputFieldError("subCategoryId", "Please Select Sub Category Name")
      isValid = false;
    }
    if (!yatraPackageName) {
      handleInputFieldError("yatraPackageName", "Please Enter Yatra Package Name")
      isValid = false;
    }
    if (!bytes) {
      handleInputFieldError("yatraPackageImage", "Please Select Image")
      isValid = false;
    }
    if (!yatraPackagePrice) {
      handleInputFieldError("yatraPackagePrice", "Please Enter Price")
      isValid = false;
    }
    if (!yatraPackageDescription) {
      handleInputFieldError("yatraPackageDescription", "Please Enter Description")
      isValid = false;
    }
    if (!yatraType) {
      handleInputFieldError("yatraType", "Please Select Yatra Type")
      isValid = false;
    }
    return isValid;
  };

  //! Handle Submit - Creating Yatra Package
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("Yatra Package Data :: ", { ...yatraPackageDetail, yatraPackageImage, includedBullet, notIncludedBullet })
      const { categoryId, subCategoryId, yatraPackageName, yatraPackageDescription, yatraPackagePrice, yatraType } = yatraPackageDetail;

      let formData = new FormData()
      formData.append("categoryId", categoryId)
      formData.append("subCategoryId", subCategoryId)
      if (yatraPackageDetail?.childCategoryId) formData.append("childCategoryId", yatraPackageDetail.childCategoryId)
      formData.append("title", yatraPackageName)
      formData.append("price", yatraPackagePrice)
      formData.append("priceMax", yatraPackageDetail.yatraPackagePriceMax || yatraPackagePrice)
      formData.append("description", yatraPackageDescription)
      formData.append("included", includedBullet)
      formData.append("not_included", notIncludedBullet)
      formData.append("yatra_type", yatraType)
      formData.append("image", yatraPackageImage?.bytes);

      const payload = {
        data: formData,
        onComplete: () => navigate("/yatra")
      }

      //! Dispatching API for Creating Yatra
      dispatch(YatraActions.createYatra(payload))
    }
  };

  useEffect(() => {
    //! Dispatching API for Getting Category
    dispatch(CategoryActions.getCategory())
  }, []);

  useEffect(() => {
    //! Dispatching API for Getting Sub Category
    yatraPackageDetail?.categoryId && dispatch(SubCategoryActions.getSubCategoryByCategoryId({ categoryId: yatraPackageDetail?.categoryId }))
  }, [yatraPackageDetail?.categoryId]);


  useEffect(() => {
    // Fetch child categories when subCategoryId changes
    if (yatraPackageDetail?.subCategoryId) {
      const apiBase = process.env.REACT_APP_API_URL || 'https://api.bharatdarshan.app/api';
      axios.get(`${apiBase}/admin/getChildCategories`, { params: { subCategoryId: yatraPackageDetail.subCategoryId } })
        .then(r => setChildCategories(r.data.data || r.data.results || []))
        .catch(() => setChildCategories([]));
    } else {
      setChildCategories([]);
    }
    setYatraPackageDetail(prev => ({ ...prev, childCategoryId: '' }));
  }, [yatraPackageDetail?.subCategoryId]);


  return (
    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Yatra Package</div>
          <div onClick={() => navigate("/yatra")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          {/* <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Redirect Page</InputLabel>
              <Select
                label="Select Status" variant="outlined" fullWidth
                name='redirectPage'
                value={yatraPackageDetail?.redirectPage}
                onChange={handleInputField}
                error={inputFieldError.redirectPage ? true : false}
                onFocus={() => handleInputFieldError("redirectPage", null)}
              >
                <MenuItem disabled>---Select Redirect Page---</MenuItem>
                {RedirectPageData.map((value, index) => (<MenuItem key={index} value={value}>{value}</MenuItem>))}
              </Select>
            </FormControl>
            {inputFieldError?.redirectPage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.redirectPage}</div>}
          </Grid> */}

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Category Name</InputLabel>
              <Select
                label="Select Category Name" variant="outlined" fullWidth
                name='categoryId'
                value={yatraPackageDetail?.categoryId}
                onChange={handleInputField}
                error={inputFieldError?.categoryId ? true : false}
                onFocus={() => handleInputFieldError("categoryId", null)}
              >
                <MenuItem disabled>---Select Category Name---</MenuItem>
                {redirectCategoryData.map((value, index) => {
                  return <MenuItem key={index} value={value?._id}>{value?.category_name}</MenuItem>
                })}
              </Select>
            </FormControl>
            {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
          </Grid>


          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Sub Category</InputLabel>
              <Select
                label="Select Sub Category" variant="outlined" fullWidth
                name='subCategoryId'
                value={yatraPackageDetail?.subCategoryId}
                onChange={handleInputField}
                error={inputFieldError?.subCategoryId ? true : false}
                onFocus={() => handleInputFieldError("subCategoryId", null)}
              >
                {subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>---Please First Select category---</MenuItem> : <MenuItem disabled>---Select Sub Category---</MenuItem>}
                {subCatgeoryDataByCategoryId && subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>You don't have Sub category</MenuItem> : subCatgeoryDataByCategoryId?.map(value => (<MenuItem key={value?._id} value={value?._id}>{value?.sub_category_name}</MenuItem>))}
              </Select>
            </FormControl>
            {inputFieldError?.subCategoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.subCategoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="child-cat-label">Select Child Category (Optional)</InputLabel>
              <Select
                label="Select Child Category (Optional)" variant="outlined" fullWidth
                name='childCategoryId'
                value={yatraPackageDetail?.childCategoryId || ''}
                onChange={handleInputField}
              >
                <MenuItem value="">---None---</MenuItem>
                {childCategories?.map(value => (
                  <MenuItem key={value?._id} value={value?._id}>{value?.child_category_name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Yatra Package Name" variant='outlined' fullWidth
              name='yatraPackageName'
              value={yatraPackageDetail?.yatraPackageName}
              onChange={handleInputField}
              error={inputFieldError.yatraPackageName ? true : false}
              helperText={inputFieldError.yatraPackageName}
              onFocus={() => handleInputFieldError("yatraPackageName", null)}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={6} >
            <TextField
              label="Price From (₹)" variant='outlined' fullWidth
              name='yatraPackagePrice'
              type='number'
              value={yatraPackageDetail?.yatraPackagePrice}
              onChange={handleInputField}
              error={inputFieldError.yatraPackagePrice ? true : false}
              helperText={inputFieldError.yatraPackagePrice}
              onFocus={() => handleInputFieldError("yatraPackagePrice", null)}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={6} >
            <TextField
              label="Price To (₹)" variant='outlined' fullWidth
              name='yatraPackagePriceMax'
              type='number'
              value={yatraPackageDetail?.yatraPackagePriceMax}
              onChange={handleInputField}
              error={inputFieldError.yatraPackagePriceMax ? true : false}
              helperText={inputFieldError.yatraPackagePriceMax || 'Leave empty for single price'}
              onFocus={() => handleInputFieldError("yatraPackagePriceMax", null)}
            />
          </Grid>

          <Grid item lg={6} sm={6} md={12} xs={12} >
            <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
              <Grid item xs={2} >
                <Avatar src={yatraPackageImage.file} style={{ width: 40, height: 40 }} />
              </Grid>
              <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                Upload Yatra Package Image
                <input onChange={handleYatraPackageImage} hidden accept="image/*" type="file" />
              </Grid>
            </Grid>
            {inputFieldError?.yatraPackageImage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.yatraPackageImage}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Type</InputLabel>
              <Select
                label="Select Type" variant="outlined" fullWidth
                name='yatraType'
                value={yatraPackageDetail?.yatraType}
                onChange={handleInputField}
                error={inputFieldError.yatraType ? true : false}
                onFocus={() => handleInputFieldError("yatraType", null)}
              >
                <MenuItem disabled>---Select Yatra Type---</MenuItem>
                <MenuItem value="Basic">Basic</MenuItem>
                <MenuItem value="Premium">Premium</MenuItem>
              </Select>
            </FormControl>
            {inputFieldError?.yatraType && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.yatraType}</div>}
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ alignItems: "center" }} spacing={3}>
              {includedBullet.map((bullet, index) => (
                <Grid item lg={6} md={6} sm={12} xs={12} key={index}>
                  <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                    <TextField
                      label={`Included Bullet ${index + 1}`}
                      variant="outlined"
                      fullWidth
                      value={bullet}
                      onChange={(e) => handleIncludedBulletChange(index, e)}
                    />
                    <div style={{ cursor: 'pointer', color: index == 0 ? 'grey' : 'red', position: "absolute", right: "10px" }} onClick={() => handleRemoveIncludedBulletField(index)} >
                      <CrossSvg w={'20'} />
                    </div>
                    {index === 0 && <div style={{ cursor: 'pointer', color: 'green', position: "absolute", right: "30px" }} onClick={() => handleAddIncludedBulletField()} >
                      <AddSvg w={'24'} />
                    </div>}
                  </div>
                </Grid>
              ))}
              {notIncludedBullet.map((bullet, index) => (
                <Grid item lg={6} md={6} sm={12} xs={12} key={index}>
                  <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                    <TextField
                      label={`Not Included Bullet ${index + 1}`}
                      variant="outlined"
                      fullWidth
                      value={bullet}
                      onChange={(e) => handleNotIncludedBulletChange(index, e)}
                    />
                    <div style={{ cursor: 'pointer', color: index == 0 ? 'grey' : 'red', position: "absolute", right: "10px" }} onClick={() => handleRemoveNotIncludedBulletField(index)} >
                      <CrossSvg w={'20'} />
                    </div>
                    {index === 0 && <div style={{ cursor: 'pointer', color: 'green', position: "absolute", right: "30px" }} onClick={() => handleAddNotIncludedBulletField()} >
                      <AddSvg w={'24'} />
                    </div>}
                  </div>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12} >
            <TextField
              label="Yatra Package Description" variant='outlined' fullWidth
              name='yatraPackageDescription'
              value={yatraPackageDetail?.yatraPackageDescription}
              onChange={handleInputField}
              error={inputFieldError.yatraPackageDescription ? true : false}
              helperText={inputFieldError.yatraPackageDescription}
              onFocus={() => handleInputFieldError("yatraPackageDescription", null)}
            />
          </Grid>

          {/* <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Status</InputLabel>
              <Select
                label="Select Status" variant="outlined" fullWidth
                name='status'
                value={yatraPackageDetail?.status}
                onChange={handleInputField}
                error={inputFieldError.status ? true : false}
                onFocus={() => handleInputFieldError("status", null)}
              >
                <MenuItem disabled>---Select Status---</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
            {inputFieldError?.status && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.status}</div>}
          </Grid> */}

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AddPackage;